<template>
<div id="wrapper">
  <div class="container">
  <div id="dark" class="row text-center">
    <div class="info">
        <img src="../../assets/404.png" alt="404 error">
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  name: '404',
};
</script>

<style scoped>
#dark {
    display: block;
    visibility: visible;
}
.info {
  position: relative;
  z-index: 999;
  margin-top: 160px;
}
#wrapper {
    min-height: 100%;
    height: 100%;
    width: 100%;
}
body {
    position: relative;
    height: 100%;
    background-color: #000c2f;
}
</style>



// WEBPACK FOOTER //
// src/components/status_code/404.vue